import { PayloadAction } from '@reduxjs/toolkit';
import { Decimal } from '@snap-types/types/decimal';

import { buildQuantityBreak } from '../builders/quantity-break';
import { buildDecimalValue } from '../builders/value';
import { WritableAutoConfiguratorState } from '../slice';

type Payload = {
  lineItemUuid: string;
  uuid: string;
  sems1Cost: Decimal | null;
  sems2Cost: Decimal | null;
  osp2Price: Decimal | null;
  osp3Price: Decimal | null;
};

export function addQuantityBreak(
  state: WritableAutoConfiguratorState,
  {
    payload: { lineItemUuid, uuid, sems1Cost, sems2Cost, osp2Price, osp3Price },
  }: PayloadAction<Payload>,
) {
  const quantityBreak = buildQuantityBreak({
    lineItemUuid,
    uuid,
    sems1Cost: buildDecimalValue(sems1Cost),
    sems2Cost: buildDecimalValue(sems2Cost),
    osp2Price: buildDecimalValue(osp2Price),
    osp3Price: buildDecimalValue(osp3Price),
    isPending: true,
  });

  state.lineItems[lineItemUuid].quantityBreakUuids.push(quantityBreak.uuid);
  state.quantityBreaks[quantityBreak.uuid] = quantityBreak;
}
